import React from "react";
import Modal from "./Modal";
import { Translate } from "react-redux-i18n";
import QRCode from "qrcode.react";
import { FaMapMarkerAlt, FaExternalLinkAlt } from "react-icons/fa";
import "./styles/ModalStoreLocation.css";

function buildFullAddress(marketstore) {
  return [marketstore?.Address, marketstore?.City, marketstore?.State]
    .map((part) => (part || "").trim())
    .filter(Boolean)
    .join(", ");
}

function getMapsUrl(marketstore) {
  const query = buildFullAddress(marketstore);
  if (!query) return "";
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}

function LocationField({ label, value }) {
  const hasValue = Boolean(value?.trim());

  return (
    <div className="store-location-modal-field">
      <p className="store-location-modal-field-label">{label}</p>
      {hasValue ? (
        <p className="store-location-modal-field-value">{value}</p>
      ) : (
        <p className="store-location-modal-field-value store-location-modal-field-empty">
          —
        </p>
      )}
    </div>
  );
}

function ModalStoreLocation({ isOpen, onClose, marketstore }) {
  const state = marketstore?.State?.trim() || "";
  const city = marketstore?.City?.trim() || "";
  const address = marketstore?.Address?.trim() || "";
  const fullAddress = buildFullAddress(marketstore);
  const mapsUrl = getMapsUrl(marketstore);
  const hasLocation = Boolean(fullAddress);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={<Translate value="marketstore_location" />}
    >
      <div className="store-location-modal">
        <div className="store-location-modal-hero">
          <div className="store-location-modal-icon">
            <FaMapMarkerAlt />
          </div>
          {marketstore?.Name && (
            <h2 className="store-location-modal-name">{marketstore.Name}</h2>
          )}
          {hasLocation && (
            <p className="store-location-modal-summary">{fullAddress}</p>
          )}
        </div>

        {hasLocation ? (
          <>
            <div className="store-location-modal-fields">
              <LocationField
                label={<Translate value="marketstore_state" />}
                value={state}
              />
              <LocationField
                label={<Translate value="marketstore_city" />}
                value={city}
              />
              <LocationField
                label={<Translate value="marketstore_address" />}
                value={address}
              />
            </div>

            {mapsUrl && (
              <a
                className="store-location-modal-maps-btn"
                href={mapsUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaExternalLinkAlt />
                <Translate value="marketstore_location_open_maps" />
              </a>
            )}

            {mapsUrl && (
              <div className="store-location-modal-qr">
                <p className="store-location-modal-qr-label">
                  <Translate value="marketstore_location_qr_label" />
                </p>
                <div className="store-location-modal-qr-canvas">
                  <QRCode value={mapsUrl} size={168} level="M" includeMargin />
                </div>
                <p className="store-location-modal-qr-hint">
                  <Translate value="marketstore_location_qr_hint" />
                </p>
              </div>
            )}
          </>
        ) : (
          <div className="store-location-modal-empty">
            <p className="store-location-modal-empty-text">
              <Translate value="marketstore_location_empty" />
            </p>
          </div>
        )}

        <div className="store-location-modal-footer">
          <button
            type="button"
            className="store-location-modal-close"
            onClick={onClose}
          >
            <Translate value="close" />
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default ModalStoreLocation;
